import type FirebaseType from "firebase/compat/app";
import getFirebase from "../../../api/firebase";
import { getProductType } from "../../../product/api";
import type { Product, UserProductsQuery, AdminProductsQuery } from "./types";

export const fetchProduct = async (uid: string): Promise<Product | null> => {
  const firebase = await getFirebase();

  const doc = await firebase.firestore().collection("products").doc(uid).get();

  if (!doc.exists) {
    return null;
  }

  return doc.data() as Product;
};

export const fetchUserProducts = async ({
  userId,
  status,
  name,
}: UserProductsQuery): Promise<Product[]> => {
  const firebase = await getFirebase();

  let query: FirebaseType.firestore.Query = firebase
    .firestore()
    .collection("products")
    .where("userId", "==", userId);

  if (status) {
    query = query.where("status", "==", status);
  }

  if (name) {
    query = query.where("name", "==", name);
  }

  const results = await query.get();

  return results.docs
    .map((doc) => doc.data() as Product)
    .filter((product) => {
      const productType = getProductType(product.name);
      return !!productType;
    });
};

export const fetchAllProducts = async ({
  status,
  name,
  limit = 100,
}: AdminProductsQuery): Promise<Product[]> => {
  const firebase = await getFirebase();

  let query: FirebaseType.firestore.Query = firebase.firestore().collection("products");

  // Apply where clauses first
  if (status) {
    query = query.where("status", "==", status);
  }

  if (name) {
    query = query.where("name", "==", name);
  }

  // Then orderBy
  query = query.orderBy("time", "desc");

  // Finally limit
  query = query.limit(limit);

  const results = await query.get();
  return results.docs.map((doc) => doc.data() as Product);
};
